import { render, staticRenderFns } from "./UnionsFormPage.vue?vue&type=template&id=57e81c28&"
import script from "./UnionsFormPage.vue?vue&type=script&lang=js&"
export * from "./UnionsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports